/**
 * ClayGo özel ölçü — custom element davranışı
 *
 * Fiyat formülü PHP api.php ile birebir (tiers, per_m2/per_cm, extras, ceil_try).
 * Sepete eklerken fiyat istemciye güvenilmez; sunucunun döndürdüğü cart_url kullanılır.
 *
 * Not: claygo-pdp.js aynı tag'i önce tanımlayabilir. Bu dosya her durumda
 * ClaygoOzelOlcuController ile elementi güçlendirir.
 */
(function () {
  'use strict';

  /**
   * Ölçüyü kademeye yuvarla. tiers boşsa gerçek değer.
   * @param {number} cm
   * @param {number[]} tiers
   * @returns {number}
   */
  function applyDimensionTier(cm, tiers) {
    if (!tiers || !tiers.length) return cm;
    var sorted = tiers.slice().sort(function (a, b) {
      return a - b;
    });
    for (var i = 0; i < sorted.length; i++) {
      if (cm <= sorted[i]) return sorted[i];
    }
    return cm;
  }

  /**
   * Fiyat yuvarlama — ceil_try: yukarı tam TL
   * @param {number} price
   * @param {string} mode
   * @returns {number}
   */
  function roundPrice(price, mode) {
    if (mode === 'ceil_try') return Math.ceil(price);
    return Math.round(price * 100) / 100;
  }

  /**
   * PHP claygoCalculatePrice ile aynı formül.
   * KDV dahil birim fiyattan ekstra çarpan YOK.
   */
  function calculatePrice(width, height, basePrice, opts) {
    opts = opts || {};
    var tiers = opts.tiers || [];
    var model = opts.pricingModel || 'per_m2';
    var extrasDef = opts.extrasDef || [];
    var selected = opts.selectedExtras || [];
    var rounding = opts.priceRounding || 'ceil_try';

    var w = applyDimensionTier(width, tiers);
    var h = applyDimensionTier(height, tiers);
    var areaM2 = (w / 100) * (h / 100);
    var longCm = Math.max(w, h);

    var price = model === 'per_cm' ? longCm * basePrice : areaM2 * basePrice;

    var byKey = {};
    extrasDef.forEach(function (ex) {
      if (ex && ex.key) byKey[ex.key] = ex;
    });
    selected.forEach(function (key) {
      var ex = byKey[key];
      if (!ex) return;
      var exPrice = parseFloat(ex.price) || 0;
      if (ex.price_type === 'per_m2') price += areaM2 * exPrice;
      else price += exPrice;
    });

    price = roundPrice(price, rounding);

    return {
      billedWidth: w,
      billedHeight: h,
      areaM2: Math.round(areaM2 * 10000) / 10000,
      longCm: longCm,
      price: price,
    };
  }

  function formatTry(amount) {
    return (
      Number(amount).toLocaleString('tr-TR', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }) + ' TL'
    );
  }

  function parseTiers(str) {
    if (!str || !String(str).trim()) return [];
    return String(str)
      .split(',')
      .map(function (s) {
        return parseFloat(s.trim());
      })
      .filter(function (n) {
        return !isNaN(n) && n > 0;
      });
  }

  /**
   * @param {HTMLElement} el
   */
  function ClaygoOzelOlcuController(el) {
    this.el = el;
    this.apiUrl = el.dataset.apiUrl || '';
    this.store = el.dataset.store || 'tr';
    this.basePrice = parseFloat(el.dataset.basePrice || el.dataset.pricePerCm2 || '0') || 0;
    this.minEn = parseFloat(el.dataset.minEn || '10') || 10;
    this.maxEn = parseFloat(el.dataset.maxEn || '300') || 300;
    this.minBoy = parseFloat(el.dataset.minBoy || '10') || 10;
    this.maxBoy = parseFloat(el.dataset.maxBoy || '300') || 300;
    this.pricingModel = el.dataset.pricingModel || 'per_m2';
    this.priceRounding = el.dataset.priceRounding || 'ceil_try';
    this.tiers = parseTiers(el.dataset.tiers || '');
    this.extrasDef = [];
    try {
      if (el.dataset.extras) this.extrasDef = JSON.parse(el.dataset.extras);
    } catch (e) {
      this.extrasDef = [];
    }

    this.widthInput = el.querySelector('[data-claygo-size-w]');
    this.heightInput = el.querySelector('[data-claygo-size-h]');
    this.shapeSelect = el.querySelector('[data-claygo-size-shape]');
    this.extrasBox = el.querySelector('[data-claygo-size-extras]');
    this.resultBox = el.querySelector('[data-claygo-size-result]');
    this.priceEl = el.querySelector('[data-claygo-size-price]');
    this.metaEl = el.querySelector('[data-claygo-size-meta]');
    this.errorEl = el.querySelector('[data-claygo-size-error]');
    this.submitBtn = el.querySelector('[data-claygo-size-submit]');
    this.labelEl = el.querySelector('[data-claygo-size-submit-label]');
    this.loadingEl = el.querySelector('[data-claygo-size-submit-loading]');

    this.fields = Array.prototype.slice.call(
      el.querySelectorAll('input[name^="properties"], textarea[name^="properties"], select[name^="properties"]')
    );

    this.onInput = this.updatePreview.bind(this);
    this.fields.forEach(
      function (field) {
        field.addEventListener('input', this.onInput);
        field.addEventListener('change', this.onInput);
      }.bind(this)
    );

    if (this.submitBtn) {
      this.submitBtn.addEventListener('click', this.onSubmit.bind(this));
    }

    this.renderExtras();
    this.fetchRemoteConfig();
    this.updatePreview();

    // pdp.js uyumu: boş property alanlarını sepete göndermeden önce kapat
    el.disableEmptyFields = this.disableEmptyFields.bind(this);
  }

  ClaygoOzelOlcuController.prototype.renderExtras = function () {
    if (!this.extrasBox) return;
    this.extrasBox.innerHTML = '';
    if (!this.extrasDef.length) {
      this.extrasBox.hidden = true;
      return;
    }
    this.extrasBox.hidden = false;
    var self = this;
    this.extrasDef.forEach(function (ex) {
      if (!ex || !ex.key) return;
      var id = 'ClaygoExtra-' + ex.key + '-' + (self.el.dataset.productId || '');
      var wrap = document.createElement('label');
      wrap.className = 'claygo-size__extra';
      wrap.setAttribute('for', id);
      var cb = document.createElement('input');
      cb.type = 'checkbox';
      cb.id = id;
      cb.value = ex.key;
      cb.dataset.claygoExtra = ex.key;
      cb.addEventListener('change', self.onInput);
      wrap.appendChild(cb);
      wrap.appendChild(document.createTextNode(' ' + (ex.label || ex.key)));
      self.extrasBox.appendChild(wrap);
    });
  };

  ClaygoOzelOlcuController.prototype.selectedExtras = function () {
    return Array.prototype.slice
      .call(this.el.querySelectorAll('[data-claygo-extra]:checked'))
      .map(function (cb) {
        return cb.value;
      });
  };

  /** API'den şekil/extras/tiers çek (varsa yerel config'i güncelle) */
  ClaygoOzelOlcuController.prototype.fetchRemoteConfig = function () {
    if (!this.apiUrl) return;
    var self = this;
    var url = this.apiUrl + (this.apiUrl.indexOf('?') >= 0 ? '&' : '?') + 'config=1';
    fetch(url, { method: 'GET', credentials: 'omit' })
      .then(function (r) {
        return r.json();
      })
      .then(function (data) {
        if (!data || !data.success) return;
        if (Array.isArray(data.tiers)) self.tiers = data.tiers;
        if (data.pricing_model) self.pricingModel = data.pricing_model;
        if (data.price_rounding) self.priceRounding = data.price_rounding;
        if (Array.isArray(data.extras)) {
          self.extrasDef = data.extras;
          self.renderExtras();
        }
        self.updatePreview();
      })
      .catch(function () {
        /* API henüz yüklü değilse sessizce yerel formülle devam */
      });
  };

  ClaygoOzelOlcuController.prototype.validate = function () {
    var w = parseFloat(this.widthInput && this.widthInput.value);
    var h = parseFloat(this.heightInput && this.heightInput.value);
    if (!(w > 0) || !(h > 0)) return 'En ve boy girin.';
    if (w < this.minEn || h < this.minBoy) {
      return 'Minimum ölçü: ' + this.minEn + ' × ' + this.minBoy + ' cm';
    }
    if ((this.maxEn > 0 && w > this.maxEn) || (this.maxBoy > 0 && h > this.maxBoy)) {
      return 'Maksimum ölçü: ' + this.maxEn + ' × ' + this.maxBoy + ' cm';
    }
    return null;
  };

  ClaygoOzelOlcuController.prototype.showError = function (msg) {
    if (!this.errorEl) return;
    if (!msg) {
      this.errorEl.hidden = true;
      this.errorEl.textContent = '';
      return;
    }
    this.errorEl.hidden = false;
    this.errorEl.textContent = msg;
  };

  ClaygoOzelOlcuController.prototype.updatePreview = function () {
    var err = this.validate();
    if (err && (!(parseFloat(this.widthInput && this.widthInput.value) > 0) || !(parseFloat(this.heightInput && this.heightInput.value) > 0))) {
      if (this.resultBox) this.resultBox.hidden = true;
      this.showError('');
      return;
    }
    if (err) {
      if (this.resultBox) this.resultBox.hidden = true;
      this.showError(err);
      return;
    }
    this.showError('');

    if (!(this.basePrice > 0)) {
      if (this.resultBox) this.resultBox.hidden = true;
      return;
    }

    var w = parseFloat(this.widthInput.value);
    var h = parseFloat(this.heightInput.value);
    var calc = calculatePrice(w, h, this.basePrice, {
      tiers: this.tiers,
      pricingModel: this.pricingModel,
      extrasDef: this.extrasDef,
      selectedExtras: this.selectedExtras(),
      priceRounding: this.priceRounding,
    });

    if (this.resultBox) this.resultBox.hidden = false;
    if (this.priceEl) this.priceEl.textContent = formatTry(calc.price);
    if (this.metaEl) {
      var meta =
        this.pricingModel === 'per_cm'
          ? 'Uzun kenar (fatura): ' + calc.longCm + ' cm'
          : 'Alan (fatura): ' + calc.areaM2 + ' m² · ' + calc.billedWidth + '×' + calc.billedHeight + ' cm';
      this.metaEl.textContent = meta;
    }

    // pdp.js update uyumu (varsa result text)
    var legacy = this.el.querySelector('[data-claygo-size-result]');
    if (legacy && legacy !== this.resultBox && legacy.tagName === 'P') {
      legacy.hidden = false;
      legacy.textContent = 'Tahmini fiyat: ' + formatTry(calc.price);
    }
  };

  ClaygoOzelOlcuController.prototype.setLoading = function (on) {
    if (this.submitBtn) this.submitBtn.disabled = !!on || !(this.basePrice > 0) || !this.apiUrl;
    if (this.labelEl) this.labelEl.hidden = !!on;
    if (this.loadingEl) this.loadingEl.hidden = !on;
  };

  ClaygoOzelOlcuController.prototype.disableEmptyFields = function () {
    this.fields.forEach(function (field) {
      if (field.type === 'checkbox' || field.tagName === 'SELECT') return;
      field.disabled = String(field.value || '').trim() === '';
    });
  };

  ClaygoOzelOlcuController.prototype.onSubmit = function (ev) {
    if (ev) ev.preventDefault();
    var err = this.validate();
    if (err) {
      this.showError(err);
      return;
    }
    if (!(this.basePrice > 0)) {
      this.showError('Birim fiyat tanımlı değil; özel ölçü API ile sepete eklenemez.');
      return;
    }
    if (!this.apiUrl) {
      this.showError('API adresi yapılandırılmamış.');
      return;
    }

    var w = parseFloat(this.widthInput.value);
    var h = parseFloat(this.heightInput.value);
    var shape = (this.shapeSelect && this.shapeSelect.value) || 'DIKDORTGEN';

    var payload = {
      store: this.store,
      width: w,
      height: h,
      shape: shape,
      base_price: this.basePrice,
      max_width: this.maxEn,
      max_height: this.maxBoy,
      min_width: this.minEn,
      min_height: this.minBoy,
      product_id: String(this.el.dataset.productId || ''),
      product_gid: this.el.dataset.productGid || '',
      product_title: this.el.dataset.productTitle || '',
      product_image: this.el.dataset.productImage || null,
      extras: this.selectedExtras(),
      fringed: false,
    };

    this.setLoading(true);
    this.showError('');

    var self = this;
    fetch(this.apiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'omit',
      body: JSON.stringify(payload),
    })
      .then(function (r) {
        return r.json().then(function (data) {
          return { ok: r.ok, data: data };
        });
      })
      .then(function (res) {
        self.setLoading(false);
        if (!res.data || !res.data.success || !res.data.cart_url) {
          var msg =
            (res.data && (res.data.error || (res.data.details && JSON.stringify(res.data.details)))) ||
            'Sipariş oluşturulamadı.';
          self.showError(String(msg));
          return;
        }
        // Sunucu fiyatı / cart_url — istemci fiyatına güvenilmez
        window.location.href = res.data.cart_url;
      })
      .catch(function () {
        self.setLoading(false);
        self.showError('Bağlantı hatası. API sunucusunu kontrol edin.');
      });
  };

  function enhance(el) {
    if (!el || el.__claygoOzelOlcu) return;
    el.__claygoOzelOlcu = new ClaygoOzelOlcuController(el);
  }

  function boot() {
    document.querySelectorAll('claygo-custom-size').forEach(enhance);
  }

  // Element henüz tanımlı değilse bizim sınıfımızla tanımla
  if (!customElements.get('claygo-custom-size')) {
    customElements.define(
      'claygo-custom-size',
      class extends HTMLElement {
        connectedCallback() {
          enhance(this);
        }
      }
    );
  } else {
    // pdp.js önce tanımladı — mevcut ve gelecek instance'ları güçlendir
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
    // Tema section yeniden render (Shopify) için
    document.addEventListener('shopify:section:load', boot);
  }

  // Dışa aktarım (test / debug)
  window.ClaygoCustomSizeMath = {
    applyDimensionTier: applyDimensionTier,
    calculatePrice: calculatePrice,
    roundPrice: roundPrice,
  };
})();
